"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _tableColumn = _interopRequireDefault(require("@/components/tableColumn/tableColumn.vue"));
var _roleMenu = require("@/api/roleMenu/roleMenu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  data: function data() {
    return {
      registrationdata: ""
    };
  },
  props: {
    title: [String],
    registrationList: Boolean,
    funBtns: {
      default: function _default() {
        return [];
      }
    },
    defaultColumn: {
      default: function _default() {
        return [];
      }
    },
    isShowSelectChange: {
      default: function _default() {
        return false;
      }
    },
    desc: [Object]
  },
  components: {
    TableColumn: _tableColumn.default
  },
  mounted: function mounted() {
    this.getOptionBtn();
  },
  methods: {
    getOptionBtn: function getOptionBtn() {
      var _this = this;
      //type 3.列表按钮，4.操作项按钮
      if (this.funBtns.length == 0) {
        var router = this.$route.path;
        (0, _roleMenu.getOptionBtnByRouter)({
          router: router,
          type: 4
        }).then(function (res) {
          res.data.forEach(function (item) {
            _this.funBtns.push({
              size: "small",
              click: item.component,
              type: item.router,
              icon: item.icon,
              name: item.name
            });
          });
        });
      }
    },
    selectChange: function selectChange(value) {
      this.$emit("selectChange", value);
      Array.isArray(value) && this.defaultColumn.map(function (column) {
        column.isShow = false;
        value.map(function (item) {
          if (item === column.name) {
            column.isShow = true;
          }
        });
      });
    },
    bindClick: function bindClick(click) {
      this.$emit(click);
    }
  }
};